import Scene = Phaser.Scene;
import Text = Phaser.GameObjects.Text;
import {Artifact, EffectType} from "@/store/artifact/types";
import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import TimeUtils from "@/utils/time-utils";
import {Fonts} from "@/constants/font";
import SkillUtils from "@/utils/skill-utils";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export enum UnlockState { UNLOCKED, LOCKED, CAN_UNLOCK }

export class ArtifactSlot extends Phaser.GameObjects.Container {

    private clickCallback: (() => unknown) | undefined;

    private readonly art: Artifact | undefined;
    private timeText: Text | undefined;
    private unlockState: UnlockState | undefined;
    private size: number;

    constructor(scene: Scene, x: number, y: number, size: number, art: Artifact, mayUpdate: boolean, unlockState: UnlockState, clickCallback: () => unknown) {
        super(scene);
        this.clickCallback = clickCallback;

        this.scene = scene;
        this.x = x;
        this.y = y;
        this.art = art;
        this.unlockState = unlockState;
        this.size = size;

        const slotImage = SpriteUtils.addImage(this.scene, 0, 0, Keys.ATLAS_PROFILE, ArtifactSlot.getSlotImage(art, unlockState))
            .setOrigin(0.5, 0.5).setInteractive();
        SpriteUtils.setDispSize(slotImage, size, size);

        slotImage.on('pointerdown', () => {
        });

        slotImage.on('pointerup', () => {
            clickCallback();
        });

        this.add(slotImage);

        if (!art) {
            return;
        }

        const artImage = SpriteUtils.addImage(this.scene, 0, 0, art.atlasKey, art.imageKey, 1 / CU.S, 1 / CU.S).setOrigin(0.5, 0.5);

        const halfLength = 45;
        const effectIcon = SpriteUtils.addImage(this.scene,
            ArtifactSlot.getEffectIconPosX(art.effectType) / CU.S,
            ArtifactSlot.getEffectIconPosY(art.effectType) / CU.S,
            Keys.ATLAS_UI,
            ArtifactSlot.getEffectIcon(art.effectType), 1 / CU.S, 1 / CU.S).setOrigin(0.5, 0.5);

        let effectText = TextUtils.addText(scene, SkillUtils.formatHealth(art.effectValue),
            (-halfLength + 3) / CU.S, halfLength / CU.S, '#f3f3f3', 12 / CU.S, 'bold', 450).setOrigin(0.5, 0.5);

        this.add([artImage, effectIcon, effectText]);

        if (mayUpdate) {
            const levelUpIcon = SpriteUtils.addImage(this.scene, 28 / CU.S, 24 / CU.S, Keys.ATLAS_PROFILE, Keys.UI_ART_UPPER_ICON).setOrigin(0.5, 0.5);
            SpriteUtils.setDispSize(levelUpIcon, 32, 24);
            //const lighting = SpriteUtils.addImage(this.scene, 0, 0, Keys.UI_ART_SLOT_LIGHT).setOrigin(0.5, 0.5);
            // levelUpIcon.setAlpha(0);
            // this.scene.tweens.timeline({
            //     targets: levelUpIcon,
            //     loop: -1,
            //     yoyo: true,
            //     tweens: [{
            //     },
            //         {
            //             delay: 2000,
            //             duration: 2500,
            //             alpha: 1,
            //             hold: 1000
            //         }]
            // });
            this.add([levelUpIcon]);
        }

    }

    public refreshTimer(): boolean {
        if (this.art && this.art.updatingTill && this.art.updatingTill > 0) {
            const remainSec = Math.floor((this.art.updatingTill - TimeUtils.getServerTimeMs()) / 1000);
            if (this.timeText) {
                this.timeText.setText(TimeUtils.getDurationText(Math.max(remainSec, 0)));
            } else {
                this.timeText = TextUtils.addTextByFamily(this.scene, TimeUtils.getDurationText(remainSec),
                    0, 10 + 15 / CU.S, '#ffffff', 11 / CU.S, 'bold', this.size / CU.S, Fonts.MYRIADPRO_BOLD).setOrigin(0.5, 0.5);
                this.add(this.timeText);
            }
            return remainSec < 0;
        }
        return false;
    }

    public getUnlockState() {
        return this.unlockState;
    }

    private static getEffectIconPosX(effectType: EffectType): number {
        const halfLength = 46;
        switch (effectType) {
            case EffectType.ATTACK:
                return -halfLength + 5;
            case EffectType.DEFENCE:
                return -halfLength + 5;
            case EffectType.ATTACK_DEFENCE:
                return -halfLength;
        }
        return -halfLength;
    }

    private static getEffectIconPosY(effectType: EffectType): number {
        const halfLength = 44;
        switch (effectType) {
            case EffectType.ATTACK:
                return halfLength - 1;
            case EffectType.DEFENCE:
                return halfLength + 2;
            case EffectType.ATTACK_DEFENCE:
                return halfLength - 8;
        }
        return halfLength - 8;
    }

    public setOrigin(x: number, y: number): void {
        // do nothing
    }

    private static getEffectIcon(effectType: EffectType): string {
        switch (effectType) {
            case EffectType.ATTACK:
                return Keys.UI_CARD_ATTACK_ICON_GOLD;
            case EffectType.DEFENCE:
                return Keys.UI_CARD_DEFENCE_ICON_GOLD;
            case EffectType.ATTACK_DEFENCE:
                break;
            case EffectType.HEALTH:
                return 'cons_effect_health';
        }
        return '';
    }

    private static getSlotImage(art: Artifact, unlockState: UnlockState) {
        switch (unlockState) {
            case UnlockState.UNLOCKED:
                if (!art) {
                    return Keys.UI_ART_SLOT_DARK;
                }
                return Keys.UI_ART_SLOT;
            case UnlockState.LOCKED:
                return Keys.UI_ART_SLOT_LOCKED;
            case UnlockState.CAN_UNLOCK:
                return Keys.UI_ART_SLOT_UNLOCK;
        }
        return '';
    }
}
